import edmodal from "./edmodal.vue";

const install = (Vue) => {
    const instance: any = new edmodal().$mount();
    // document.body.appendChild(instance.$el);
    instance.$removeDom = () => {
        setTimeout(() => {
            document.body.removeChild(instance.$el);
        }, 200);
    };
    instance.useAsPlugin = true;
    Vue.prototype.$edModal = {};
    Vue.prototype.$edModal.show = (obj) => {
        document.body.appendChild(instance.$el);
        instance.show(obj);
    };
    Vue.prototype.$edModal.destroy = () => instance.removeNotify();
};
export default {
    install,
};
